export const RESTORE_OFFER_LIST_VIEW = 'RESTORE_OFFER_LIST_VIEW'
export const CLEAR_OFFER_LIST = 'CLEAR_OFFER_LIST'
let blockedUntil = 0

const normalizeHeaderName = name => name.replace(/-/g, '').toLowerCase()

const getHeader = (headers = {}, name) => {
  const normalizedName = normalizeHeaderName(name)
  const headerName = Object.keys(headers).find(
    key => normalizeHeaderName(key) === normalizedName
  )

  return headerName ? headers[headerName] : undefined
}

export const getOfferListRollbackView = (
  pendingRollbackView,
  activeTab,
  filters
) => pendingRollbackView || { activeTab, filters }

export const registerOfferListRateLimit = response => {
  if (!response || response.status !== 429) {
    return null
  }

  const headerRetryAfter = Number(getHeader(response.headers, 'Retry-After'))
  const retryAfter =
    Number.isFinite(headerRetryAfter) && headerRetryAfter > 0
      ? Math.ceil(headerRetryAfter)
      : 1

  blockedUntil = Date.now() + retryAfter * 1000

  return { retryAfter }
}

export const isOfferListRateLimitActive = () => blockedUntil > Date.now()

export const restoreOfferListView = (exchange, activeTab, filters) => ({
  type: RESTORE_OFFER_LIST_VIEW,
  payload: { exchange, activeTab, filters }
})

export const clearOfferList = exchange => ({
  type: CLEAR_OFFER_LIST,
  payload: { exchange }
})
